var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcnPaymentMethod(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.77954 2.85822H23.5479",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.77954 4.26465H23.5479",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6383 5.71644V2.35916C23.6383 1.27032 22.7344 0.362946 21.6044 0.362946H8.76827C7.63833 0.362946 6.73438 1.27032 6.73438 2.35916V8.62003C6.73438 9.70888 7.63833 10.6163 8.76827 10.6163H20.7005",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6101 10.6162H21.6045C22.7344 10.6162 23.6384 9.70887 23.6384 8.62003",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5764 7.07751H8.49731V9.16447H10.5764V7.07751Z",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6555 7.98489H21.4691",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.25415 18.0567H6.01121",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2937 18.0567H15.0508",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8983 18.6465C17.8983 17.2401 17.8983 15.8336 17.8983 14.4272C17.8983 14.0189 17.7175 13.9282 17.2655 14.0189C14.8249 14.518 12.3842 14.4272 9.9887 13.7467C9.08474 13.5198 8.18079 13.3384 7.23163 13.2476C5.06214 13.0208 2.93785 13.293 0.858753 13.8828C0.451973 14.0643 0.31638 14.2004 0.361577 14.518C0.361577 16.741 0.361577 19.0095 0.361577 21.2325C0.361577 21.7769 0.361577 22.3667 0.361577 22.9112C0.361577 23.2287 0.587566 23.3195 0.949148 23.2741C1.22033 23.2287 1.44632 23.138 1.71751 23.0926C4.42937 22.3667 7.14124 22.3214 9.80791 23.0926C12.2938 23.7732 14.7797 23.8639 17.3559 23.3648C17.7627 23.2741 17.9435 23.138 17.9435 22.775C17.8983 21.414 17.8983 20.0529 17.8983 18.6465Z",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.80787 13.7467C2.39544 14.155 2.57623 14.9263 2.16945 15.5161C1.80787 16.1512 0.994309 16.3327 0.406738 15.9244",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.497 14.2457C15.9094 14.654 15.7286 15.4253 16.1354 16.0151C16.5422 16.6049 17.3105 16.7864 17.8981 16.3781",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.80787 23.0473C2.39544 22.6389 2.57623 21.8677 2.16945 21.2779C1.76267 20.6881 0.994309 20.5066 0.406738 20.8696",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.497 23.5009C15.9094 23.0926 15.7286 22.3214 16.1354 21.7316C16.5422 21.1418 17.3105 20.9603 17.8981 21.3686",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.12979 18.1929C8.63261 18.1929 8.22583 17.7845 8.22583 17.2855C8.22583 16.7864 8.63261 16.3781 9.12979 16.3781C9.62696 16.3781 10.0337 16.7864 10.0337 17.2855",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.12979 18.1928C9.62696 18.1928 10.0337 18.6012 10.0337 19.1002C10.0337 19.5993 9.62696 20.0076 9.12979 20.0076C8.63261 20.0076 8.22583 19.5993 8.22583 19.1002",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.12988 20.0983V20.5974",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.12988 15.6976V16.242",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnPaymentMethod);
export default __webpack_public_path__ + "static/media/icn-paymentMethod.d843a401.svg";
export { ForwardRef as ReactComponent };